export default __webpack_public_path__ + "static/media/Cine Buzz News.6a132722.png";